// extracted by mini-css-extract-plugin
export default {"margin-right-auto":"util_margin-right-auto__KJSuG","flex-space-evenly":"util_flex-space-evenly__gy+nt"};